module.exports = __webpack_public_path__ + "img/google_step_3.aba90f38.jpg";